import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { enGB } from "date-fns/locale";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Modal,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import moment from "moment";
import React, { useState } from "react";
import { insertPrimeStockInData } from "src/api/primestockapi";
import { notification } from "src/utils/messages";

export default function StockInsertUpdateModal({
  addEditModal,
  setAddEditModal,
  modalType,
  toggleAddEditModal,
  rowData,
  handleGetProducts,
  filterData
}) {
  // Prime has a single stock pool — the panel operator is always the real user.
  let user = JSON.parse(localStorage.getItem("userData"));

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 10,
    borderRadius: "10px",
    p: 2
  };

  const [loader, setLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [stockData, setStockData] = useState({
    p_id: rowData.p_id,
    p_qty: modalType === "Edit" ? rowData.qty : "",
    p_name: rowData.p_name,
    u_id: user?.u_id,
    u_name: user?.name,
    date:
      modalType === "Edit"
        ? typeof rowData?.sh_date === "string"
          ? rowData.sh_date.replace(/\./g, "")
          : rowData?.sh_date
        : new Date()
  });

  const resetFormData = () => {
    setStockData({
      p_id: rowData.p_id,
      p_qty: "",
      p_name: rowData.p_name,
      u_id: user?.u_id,
      u_name: user?.name,
      date: ""
    });
  };

  const handleInsertStockData = async () => {
    if (
      stockData.p_id != "" &&
      stockData.p_qty != "" &&
      stockData.p_name !== "" &&
      stockData.date !== ""
    ) {
      setLoader(true);
      setIsLoading(true);

      let resp = await insertPrimeStockInData({
        ...stockData,
        date:
          stockData.date !== "DD-MM-YYYY"
            ? moment(stockData.date).format("DD-MM-YYYY")
            : stockData.date
      });
      setIsLoading(false);
      if (resp.status != 0) {
        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message
        });
        notify();
        resetFormData();
        toggleAddEditModal();
        handleGetProducts(filterData);
      } else {
        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message
        });
        notify();
      }
      setLoader(false);
    } else {
      let notify = notification({
        type: "error",
        message: "Please Fill All Fields data"
      });
      notify();
    }
  };

  return (
    <Modal
      open={addEditModal}
      onClose={() => toggleAddEditModal()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          style={{ marginBottom: "5px", textAlign: "center" }}
        >
          {rowData.p_name}
        </Typography>
        <hr />
        <Stack style={{ marginBottom: "15px" }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Stack spacing={3} style={{ marginBottom: "5px", marginTop: "15px" }}>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={enGB}>
                  <DatePicker
                    size="small"
                    sx={{ width: "100%" }}
                    label="Date"
                    value={stockData?.date ? moment(stockData.date).toDate() : new Date()}
                    inputFormat="dd/MM/yyyy"
                    onChange={(newDate) => {
                      setStockData({
                        ...stockData,
                        date: moment(newDate).format("YYYY-MM-DD")
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: 40
                          },
                          "& .MuiInputLabel-root": {
                            top: "-6px"
                          }
                        }}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Stack>
            </Grid>
            <Grid item sm={12} xs={12} md={12} lg={12}>
              <TextField
                height={10}
                size="small"
                fullWidth
                autoComplete="off"
                type="number"
                required
                label="Quantity"
                name="p_qty"
                placeholder="Enter Quantity"
                onChange={(e) => {
                  setStockData({
                    ...stockData,
                    p_qty: e.target.value
                  });
                }}
                value={stockData?.p_qty}
              />
            </Grid>

            <Grid
              item
              sm={12}
              xs={12}
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center"
              }}
            >
              <Button
                variant="outlined"
                onClick={() => toggleAddEditModal()}
                style={{ marginTop: "15px", marginRight: "15px" }}
              >
                Close
              </Button>
              <Button
                variant="contained"
                style={{ marginTop: "15px" }}
                onClick={() => !loader && handleInsertStockData()}
                disabled={isLoading}
                startIcon={isLoading && <CircularProgress size={20} color="inherit" />}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Stack>
      </Box>
    </Modal>
  );
}
